// extracted by mini-css-extract-plugin
export default {"bg":"NFmEm5","inlineContent":"y9PrZx","pageWrapper":"iKLN_e","root":"RBwuf_"};